
const dashicon_list = [
    // Social Icons
    { label: 'Facebook', value: 'facebook-alt' },
    { label: 'Twitter', value: 'twitter' },
    { label: 'Linkedin', value: 'linkedin' },
    { label: 'Youtube', value: 'youtube' },
    { label: 'Instagram', value: 'instagram' },
    // Admin Menu
    { label: 'Globe', value: 'admin-site-alt3' },
    { label: 'World', value: 'admin-site-alt2' },
    { label: 'Attachment', value: 'admin-site-alt2' },
    { label: 'Message', value: 'admin-comments' },
    { label: 'Setting Tool', value: 'admin-tools' },
    { label: 'Star', value: 'star-filled' },
    // Post Format
    { label: 'Image Format', value: 'admin-tools' },
    { label: 'Setting', value: 'admin-generic' },
    // Media
    { label: 'Video Format', value: 'format-video' },
    { label: 'Audio Format', value: 'format-audio' },
    { label: 'Camera', value: 'camera' },
    { label: 'Camera ALT', value: 'camera-alt' },
    { label: 'Play', value: 'controls-play' },
    { label: 'Pause', value: 'controls-pause' },
    { label: 'Forward', value: 'controls-forward' },
    { label: 'Backward', value: 'controls-back' },
    { label: 'Video', value: 'video-alt2' },
    { label: 'Volume Control', value: 'controls-volumeon' },
    // Image Editing
    { label: 'Pin Post', value: 'admin-post' },
    { label: 'Rotate', value: 'image-rotate' },
    { label: 'Undo', value: 'undo' },
    { label: 'Redo', value: 'redo' },
    { label: 'Image Filter', value: 'image-filter' },
    // Arrows
    { label: 'Arrow Up', value: 'arrow-up-alt' },
    { label: 'Arrow Down', value: 'arrow-down-alt' },
    { label: 'Arrow Right', value: 'arrow-right-alt' },
    { label: 'Arrow Left', value: 'arrow-left-alt' },
    // Email Password
    { label: 'Email', value: 'email' },
    { label: 'Password', value: 'admin-network' },
    // Dummy Profile
    { label: 'Business Person', value: 'businessperson' },
    { label: 'Business Women', value: 'businesswoman' },
    { label: 'Menu', value: 'menu' },
    { label: 'Button', value: 'button' },
    { label: 'Filter', value: 'filter' },
    { label: 'Database', value: 'database' },
    { label: 'HTML', value: 'html' },
    { label: 'Filter', value: 'filter' },
    { label: 'Delete', value: 'trash' },
    { label: 'Lock', value: 'lock' },
    { label: 'Cart', value: 'cart' },
    { label: 'Search', value: 'search' },
    { label: 'Bell Notification', value: 'bell' },
    { label: 'Protective Shield', value: 'shield' },
    { label: 'Thumbs Up', value: 'thumbs-up' },
    { label: 'Phone', value: 'phone' },
    { label: 'Microphone', value: 'microphone' },
]

export default dashicon_list;